import { cookie } from '@gaodun.com/gtools';
import axios from 'axios';
import qs from 'query-string';

var _getActiveENV = function _getActiveENV() {
  var hostname = window.location.hostname;

  if (hostname.indexOf('dev-') > -1) {
    return 't-';
  }

  if (hostname.indexOf('t-') > -1) {
    return 't-';
  }

  if (hostname.indexOf('pre-') > -1) {
    return 'pre-';
  }

  return '';
};

var request = axios.create({
  baseURL: "https://".concat(_getActiveENV(), "apigateway.gaodun.com"),
  withCredentials: false,
  transformRequest: function transformRequest(data) {
    var strData = qs.stringify(data);
    return strData;
  }
});
request.interceptors.request.use(function (config) {
  config.headers['Content-Type'] = "application/json;charset=UTF-8";
  config.headers.common.Authentication = "Basic ".concat(cookie.getCookie('Accesstoken'));

  config.transformRequest = function (data) {
    return JSON.stringify(data);
  };

  return config;
}, function (error) {
  return Promise.reject(error);
}); // 预处理返回值

request.interceptors.response.use(function (response) {
  return Promise.resolve(response.data);
}, function (error) {
  return Promise.reject(error);
}); // nps查询评价弹窗问题列表  场景id 不同场景见配置表

export var getEvaluationListTask = function getEvaluationListTask(sceneId, params) {
  return request.get("/evaluation/api/v1/evaluation/".concat(sceneId), {
    params: params
  });
}; // nps 保存用户评价

export var saveEvalutionTask = function saveEvalutionTask(params) {
  return request.post('/elune/api/v1/evaluation/save', params);
}; // nps 保存用户评价

export var saveOhterEvalutionTask = function saveOhterEvalutionTask(params) {
  return request.post('/evaluation/api/v1/evaluation/save', params);
};
export var getEvaluationResultTask = function getEvaluationResultTask(params) {
  return request.get('/evaluation/api/v1/student/evaluation/result', {
    params: params
  });
};